<div class="container">
  admin-contribution-categories works!
</div>
